const CorpCustomerStatistics = () =>
  import('@/views/main/wechatMgmt/corpCustomerStatistics/CorpCustomerStatistics.vue')
export default {
  path: '/main/wechatMgmt/corpCustomerStatistics',
  name: 'CorpCustomerStatistics',
  component: CorpCustomerStatistics
}
